module.exports = __webpack_public_path__ + "app/modals/clone-to-devices.view.html";